"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MIN_PERCENTAGE = 0;
var MAX_PERCENTAGE = 100;
var MAX_X = 100;
var MAX_Y = 100;
var FULL_RADIUS = 50;
var CENTER_X = 50;
var CENTER_Y = 50;
var CircularProgressbar = (function (_super) {
    __extends(CircularProgressbar, _super);
    function CircularProgressbar(props) {
        var _this = _super.call(this, props) || this;
        _this.initialTimeout = undefined;
        _this.requestAnimationFrame = undefined;
        _this.state = {
            percentage: props.initialAnimation ? 0 : props.percentage,
        };
        return _this;
    }
    CircularProgressbar.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.initialAnimation) {
            this.initialTimeout = window.setTimeout(function () {
                _this.requestAnimationFrame = window.requestAnimationFrame(function () {
                    _this.setState({
                        percentage: _this.props.percentage,
                    });
                });
            }, 0);
        }
    };
    CircularProgressbar.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            percentage: nextProps.percentage,
        });
    };
    CircularProgressbar.prototype.componentWillUnmount = function () {
        clearTimeout(this.initialTimeout);
        if (this.requestAnimationFrame) {
            window.cancelAnimationFrame(this.requestAnimationFrame);
        }
    };
    CircularProgressbar.prototype.getBackgroundPadding = function () {
        if (this.props.background) {
            if (this.props.backgroundPadding == null) {
                return this.props.strokeWidth;
            }
            return this.props.backgroundPadding;
        }
        return 0;
    };
    CircularProgressbar.prototype.getPathDescription = function () {
        var radius = this.getPathRadius();
        var rotation = this.props.counterClockwise ? 1 : 0;
        return "\n      M " + CENTER_X + "," + CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
    };
    CircularProgressbar.prototype.getPathStyles = function () {
        var diameter = Math.PI * 2 * this.getPathRadius();
        var truncatedPercentage = Math.min(Math.max(this.state.percentage, MIN_PERCENTAGE), MAX_PERCENTAGE);
        var dashoffset = ((100 - truncatedPercentage) / 100) * diameter;
        return {
            strokeDasharray: diameter + "px " + diameter + "px",
            strokeDashoffset: (this.props.counterClockwise ? -dashoffset : dashoffset) + "px",
        };
    };
    CircularProgressbar.prototype.getPathRadius = function () {
        return FULL_RADIUS - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.render = function () {
        var _a = this.props, percentage = _a.percentage, className = _a.className, classes = _a.classes, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathDescription = this.getPathDescription();
        return (react_1.default.createElement("svg", { className: classes.root + " " + className, style: styles.root, viewBox: "0 0 " + MAX_X + " " + MAX_Y },
            this.props.background ? (react_1.default.createElement("circle", { className: classes.background, style: styles.background, cx: CENTER_X, cy: CENTER_Y, r: FULL_RADIUS })) : null,
            react_1.default.createElement("path", { className: classes.trail, style: styles.trail, d: pathDescription, strokeWidth: strokeWidth, fillOpacity: 0 }),
            react_1.default.createElement("path", { className: classes.path, d: pathDescription, strokeWidth: strokeWidth, fillOpacity: 0, style: Object.assign({}, styles.path, this.getPathStyles()) }),
            text ? (react_1.default.createElement("text", { className: classes.text, style: styles.text, x: CENTER_X, y: CENTER_Y }, text)) : null));
    };
    CircularProgressbar.defaultProps = {
        strokeWidth: 8,
        className: '',
        text: '',
        background: false,
        backgroundPadding: 0,
        initialAnimation: false,
        counterClockwise: false,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background',
        },
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {},
        },
    };
    return CircularProgressbar;
}(react_1.default.Component));
exports.default = CircularProgressbar;
//# sourceMappingURL=index.js.map